export const ENVIRONMENTS = {
  PROD: "PROD",
  DEMO: "DEMO",
  DEV: "DEVELOP",
} as const;
